export const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-IN'));
export const money = (v, c = 'INR') =>
  (v == null ? '—' : `${c === 'INR' ? '₹' : ''}${Number(v).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`);
export const pct = (v, digits = 0) => (v == null ? '—' : `${(v * 100).toFixed(digits)}%`);

// A ratio with no denominator is undefined, not zero. The engine returns the
// reason; this prints it instead of a number, because "No sales" and "0%" mean
// opposite things and a seller acting on the wrong one loses money.
export const ratio = (value, reason, digits = 0) =>
  (value == null ? (reason || '—') : `${(value * 100).toFixed(digits)}%`);

// ACOS, CPC and CPA are better when they fall.
export const LOWER_IS_BETTER = ['acos', 'cpc', 'cpa', 'tacos'];
// ACOS, CTR, CVR and TACOS move in points, not per cent.
export const IN_POINTS = ['acos', 'ctr', 'cvr', 'tacos'];

export const LABEL_TONE = {
  Healthy: 'good', Review: 'warn', 'High ACOS': 'bad', Waste: 'bad',
  'Low data': 'muted', 'No activity': 'muted', 'High performer': 'good',
};
